<template>
	<article>
    <header class="view__header">
      <h2 class="view__title">{{ parsedData.email }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <submenu v-if="this.$route.params.id"></submenu>
        <div class="form js-form">
          <div class="jquery-alpaca-edit" />
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import { Btn } from 'components/layout/forms'
import { mapGetters } from 'vuex'
import Submenu from 'components/views/members/Submenu'
import L from 'services/Localization'
import notifications from 'mixins/notifications'

export default {
  name: 'member',
  components: { Submenu, Btn },
  mixins: [notifications],
  data() {
    return {
      L: L,
      formSelector: '.jquery-alpaca-edit',
      loading: '',
      title: '',
      schema: {},
      options: {},
      parsedData: {}
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch('getMember', this.$route.params.id).then(() => {
        this.mapFromState()
        this.init()
      })
    }
  },
  computed: {
    ...mapGetters({
      member: 'activeMember',
      validation: 'getValidation'
    })
  },
  beforeDestroy() {
    $(this.formSelector).alpaca('destroy')
  },
  methods: {
    mapFromState() {
      this.schema = JSON.parse(this.member.schema)
      this.options = JSON.parse(this.member.options)
      this.parsedData = JSON.parse(this.member.data)
    },
    init() {
      // set proper enum to null if empty
      for (var newProperty in this.schema.properties) {
        if (this.schema.properties[newProperty].enum && this.schema.properties[newProperty].enum.length === 0) {
          this.schema.properties[newProperty].enum = null
        }
      }

      // set proper type for checkboxes
      for (var property in this.schema.properties) {
        if (this.schema.properties[property].enum) {
          this.schema.properties[property].type = 'string'
        }
      }

      // regex validation
      for (var prop in this.options.fields) {
        if (this.options.fields[prop].regexValidator !== undefined) {
          this.options.fields[prop].validator = function (callback) {
            var floatRegex = new RegExp(this.options.regexValidator)
            if (floatRegex.test(this.getValue())) {
              callback({ status: true })
            } else {
              callback({
                message: 'Not a valid value. Please respect restrictions [regex].',
                status: false
              })
            }
          }
        }
      }

      this.options.hideInitValidationError = 'true'
      this.options.form = {
        attributes: {
          id: 'member-form',
          method: 'post',
          action: `/old-members/${this.$route.params.id}/edit`
        },
        buttons: {
          submit: {
            title: L.localize('Label_SaveButton'),
            styles: 'form__submit button'
          },
          cancel: {
            type: 'button',
            title: L.localize('Label_CancelButton'),
            styles: 'form__submit button button--border',
            click: function() {
              window.location.href = '/app/members'
            }
          }
        },
        toggleSubmitValidState: false
      }

      var self = this;

      $(this.formSelector).alpaca({
        data: this.parsedData,
        schema: this.schema,
        options: this.options,
        view: {
          parent: 'templ-edit',
          locale: L.getAlpacaLocale()
        },
        postRender: function (renderedField) {
          var form = renderedField.form

          if (form) {
            form.registerSubmitHandler(function (e, form) {
              e.stopPropagation()

              // validate the entire form (top control + all children)
              form.validate(true)

              // draw the validation state (top control + all children)
              form.refreshValidationState(true)

              // now display something
              if (form.isFormValid()) {
                var values = this.getValue()
                $('.alpaca-field-checkbox')
                    .each(function () {
                      var $container = $(this)
                      var name = $container.data('alpaca-field-name')
                      var data = values[name]
                      $container.append('<input type="hidden" name="' +
                          name +
                          '" value="' +
                          data +
                          '"></input>')
                    })
                form.ajaxSubmit().then(() => {
                  self.showNotification({
                    title: L.localize('Label_SuccessEdit'),
                    message: L.localize('Label_Success')
                  })
                })
              }

              e.stopPropagation()

              return false
            })
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Member.vue?9fd52390